import apiService from '../../../services/api-client';
import { GetTemplatesResponse } from '../interfaces/get-templates';
import { PostTemplatePayloadRequest, PostTemplateResponse } from '../interfaces/post-template';
import { PutTemplatePayloadRequest, PutTemplateResponse } from '../interfaces/put-template';

export const templateApiService = {
  async getTemplates() {
    const { data } = await apiService().get<GetTemplatesResponse>(
      `templates`,
    );
    return data;
  },
  async postTemplate(body: PostTemplatePayloadRequest) {
    const { data } = await apiService().post<PostTemplateResponse>(
      `templates`,
      body
    );
    return data;
  },
  async putTemplate(id: string, body: PutTemplatePayloadRequest) {
    const { data } = await apiService().put<PutTemplateResponse>(
      `templates/${id}`,
      body
    );
    return data;
  },
};
